<button mat-flat-button class="playlist-tag-button"><mat-icon>tag</mat-icon><ng-content></ng-content></button>
